import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import { Alert, Col, Row, Spinner } from '@digitools/honest-react';
import React from 'react';
import PlanOverview from 'src/packages/dental/components/PlanOverview';
import AdditionalEligibilityConditions from 'src/packages/dental/components/AdditionalEligibilityConditions';
import BenefitFrequencyTables from 'src/packages/dental/components/BenefitFrequencyTables';
import { DentalTabPanel, TabsDisclaimerText } from 'src/packages/dental/Dental';
//TODO This is where the content will go in the subsequent stories, this is a placeholder
export const CoveredServicesInfo = () => {
    const { coveredServicesLoading } = useDentalDataContext();
    if (coveredServicesLoading) {
        return <Spinner data-testid='coveredServices-spinner'/>;
    }
    return (<>
        <PlanOverview />
        <BenefitFrequencyTables />
        <AdditionalEligibilityConditions />
    </>);
};
const CoveredServices = () => {
    const { currentMember, subscriber } = useDentalDataContext();
    return (<>
      {!!currentMember && !!subscriber && (<>
          <TabsDisclaimerText />
          {subscriber?.planOverview?.inNetworkOnlyClause && (<Row className={'pt-0 mt-0'}>
              <Col>
                <Alert className={' pr-2 mb-3 pt-2 pl-2'} type={'info'}>
                  {subscriber.planOverview.inNetworkOnlyClause}
                </Alert>
              </Col>
            </Row>)}
          <DentalTabPanel>
            <PlanOverview />
            <BenefitFrequencyTables />
            <AdditionalEligibilityConditions />
          </DentalTabPanel>
        </>)}
    </>);
};
export default CoveredServices;
